import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    //private currentUserSubject: BehaviorSubject<User>;
    public currentUserKey = new BehaviorSubject <string> (sessionStorage.getItem('currentUser')) ;
    public currentUser = new BehaviorSubject <boolean> (this.checkoutCurrentUser()) ;
    apiUrl = 'http://127.0.0.1:8000';
    
    constructor(private http: HttpClient) {
       // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
       
    }

  /*  public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }*/
    checkoutCurrentUser() : boolean
    {
        if(sessionStorage.getItem('currentUser') != null) {
           return true ;
        }
        return false ;}
    

    login(email: string, password: string) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
       
        return this.http.post<any>(`${this.apiUrl}/api/v1/auth/login/`, { email, password },{ headers, 
            responseType:  'json'}) ;
    }
    get currentuserStatus(){
        return this.currentUser.asObservable() ;
    }
    get currentuserkeyusername(){
        return this.currentUserKey.asObservable() ;
    }
    logout() {
        // remove user from local storage to log user out
        this.currentUser.next(false) ;
        sessionStorage.removeItem('currentUser');
        
        //this.currentUserSubject.next(null);
    }
}